export const resizePlayer = (height: number, width: number): string => {
  if (width / (height - 100) > 16 / 9)
    return `${((((height - 100) / width) * 16) / 9) * 100}%`;
  else return "100%";
};
